module.exports = __webpack_public_path__ + "static/media/Illus-EmployeeFork@3x.b0fb4db5.png";